import { render } from "./VendorLayout.vue?vue&type=template&id=12af0438"
import script from "./VendorLayout.vue?vue&type=script&lang=js"
export * from "./VendorLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__